const style = {
  marginTop: "10px",
  marginRight: "20px",
  padding: "10px",
  zIndex: 1050,
  backgroundColor: "white",
  borderColor: "#df1400",
  borderWidth: "1px",
  borderStyle: "solid",
  borderRadius: "5px",
  textAlign: "center",
};

export default style;
